import { UiSuspensefulOutlet } from '@experiences/ui-common';
import React from 'react';

import { routePaths } from '../../../common/constants/routePaths';
import useIsClusterHealthPortalAvailable from '../../../common/hooks/useIsClusterHealthPortalAvailable';
import CheckGuard from '../../../container/helpers/CheckGuard';
import type { UiRouteObject } from '../../../container/routeConfigs/UiRouteObject';

/**
 * Lazy-loaded Automation Suite Health Portal
 */
const AutomationSuiteHealthComponent = React.lazy(
    () => import('./ClusterHealthPortalComponent')
);

const ClusterHealthPortalRoute = () => {
    const isClusterHealthPortalAvailable = useIsClusterHealthPortalAvailable();

    return CheckGuard(
        isClusterHealthPortalAvailable,
        <AutomationSuiteHealthComponent />
    );
};

/**
 * ClusterHealthPortalRoutes
 *
 * Route configuration for Automation Suite Health Portal.
 */
export const ClusterHealthPortalRoutes: UiRouteObject = {
    path: routePaths.adminClusterHealthPortal,
    element: <UiSuspensefulOutlet />,
    children: [
        {
            index: true,
            element: <ClusterHealthPortalRoute />,
        },
    ],
};
